<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <section>
    <h3 class="text-center mb-1">Additional Visitor Safeguarding</h3>

    <section>
      <h4 class="text-center mb-1">Are you sure?</h4>
      <p
        v-if="completing_safe_guarding"
        class="text-center">
        You are about to complete safeguarding for {{additionalVisitor.firstname}} {{additionalVisitor.lastname}}
      </p>
      <p
        v-else
        class="text-center">
        You are about to remove the safeguarding status for {{additionalVisitor.firstname}} {{additionalVisitor.lastname}}
      </p>
    </section>
    <validation-observer ref="safeguardForm" :class="{'disabled': loading}">
      <validation-provider #default="{ errors }" name="Name" rules="required">
        <label>Name</label>
        <b-form-input cy="safe-name"
          v-model="name"
          :state="errors.length > 0 ? false:null" class="mb-1" placeholder="Enter name*"
        />
        <small class="text-danger d-block">{{ errors[0] }}</small>
      </validation-provider>
      <validation-provider #default="{ errors }" name="Notes">
        <label>Notes</label>
        <b-form-textarea cy="safe-notes"
          v-model="notes"
          :state="errors.length > 0 ? false:null" class="mb-1" placeholder="Enter notes"
        />
      </validation-provider>
    </validation-observer>

    <section class="full-width my-2 d-flex justify-content-end" :class="{'disabled': loading}">
      <b-btn variant="danger" @click="close()">Cancel</b-btn>
      <b-button class="ml-1"
                @click="validationForm()" variant="primary">Submit</b-button>
    </section>
  </section>
</template>
<!-- eslint-enable -->

<script>
import {mapState} from 'vuex';
import AdditionalVisitorsService from '@/services/AdditionalVisitorsService';

export default {
  components: {},
  props: {
    completing_safe_guarding: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      loading: false,
      name: '',
      notes: '',
    };
  },
  computed: {
    ...mapState({
      prison: state => state.prison.prison,
      additionalVisitor: state => state.participants.participant,
    }),
  },
  mounted() {

  },
  methods: {
    validationForm() {
      this.$refs.safeguardForm.validate().then(success => {
        if (success) {
          this.createSafeguarding();
        }
      })
    },
    createSafeguarding() {
      this.loading = true;

      const dto = {
        additional_visitor_id: this.additionalVisitor.additional_visitor_id,
        prison_officer_name: this.name,
        notes: this.notes,
        status: this.completing_safe_guarding,
      };

      AdditionalVisitorsService.createSafeguarding(dto).then(() => {
        this.$toast.success('Safeguarding record created!', {
          toastClassName: ['toast-std', 'success-toast'],
        });
        this.$emit('refresh', true);
      }).catch(() => {
        this.$toast.error('Unable to create safeguarding record. Please refresh the page and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loading = false;
      })
    },
    close(){
      this.$emit('close', true);
    }
  },
};
</script>
